import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Single stat item — value + label
const Stat = ({ value, label, color, t }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: "1px" }}>
    <Typography sx={{
      fontFamily: "'Inter', sans-serif",
      fontSize: "22px", fontWeight: 700,
      color: color || t.text, lineHeight: 1,
      letterSpacing: "-0.02em",
    }}>
      {value ?? "—"}
    </Typography>
    <Typography sx={{
      fontFamily: "'DM Mono', monospace",
      fontSize: "8px", letterSpacing: "0.12em",
      textTransform: "uppercase", color: t.text3,
    }}>
      {label}
    </Typography>
  </Box>
);

// Thin vertical separator
const Sep = ({ t }) => (
  <Box sx={{
    width: "1px", height: "28px",
    background: t.border2, flexShrink: 0,
  }} />
);

const StatsStrip = ({ macName, summary, loading }) => {
  const theme = useTheme();
  const t     = theme.custom;

  return (
    <Box sx={{
      display: "flex", alignItems: "center",
      gap: "20px", padding: "12px 24px",
      borderBottom: `1px solid ${t.border2}`,
      flexShrink: 0,
      background: t.surface2,
    }}>

      {/* MAC identifier badge */}
      {macName && (
        <>
          <Box sx={{
            display: "inline-flex", alignItems: "center",
            padding: "3px 10px", borderRadius: "3px",
            background: t.accent2, border: `1px solid ${t.accent}44`,
          }}>
            <Typography sx={{
              fontFamily: "'DM Mono', monospace",
              fontSize: "9px", letterSpacing: "0.12em",
              textTransform: "uppercase", color: t.accent,
              fontWeight: 600,
            }}>
              {macName}
            </Typography>
          </Box>
          <Sep t={t} />
        </>
      )}

      {/* Allocated HC — primary teal */}
      <Stat
        value={loading ? "—" : summary?.allocatedHc}
        label="Allocated HC"
        color={t.text}
        t={t}
      />

      <Sep t={t} />

      {/* Billed — teal accent */}
      <Stat
        value={loading ? "—" : summary?.billed}
        label="Billed"
        color={t.accent}
        t={t}
      />

      {/* Unbilled — gold */}
      <Stat
        value={loading ? "—" : summary?.unbilled}
        label="Unbilled"
        color={t.gold}
        t={t}
      />

      <Sep t={t} />

      {/* Pending — gold as a warning indicator */}
      <Stat
        value={loading ? "—" : summary?.pending}
        label="Pending"
        color={t.gold}
        t={t}
      />

      
    </Box>
  );
};

export default StatsStrip;